import React, {useCallback, useEffect, useRef, useState} from "react";
import {useController, useForm} from "react-hook-form";
import useSearchAsset from "../hooks/useSearchAsset";
import useRecentSearchKeywords from "../hooks/useRecentSearchKeywords";
import View from "./View";

function Container({searchKeyword}) {
  const {control, handleSubmit} = useForm({
    mode: "onSubmit",
  });

  const {
    field: {value, onChange},
  } = useController({
    control,
    name: "search",
    defaultValue: searchKeyword || "",
    rules: {required: true},
  });

  const {searchAsset, resetSearchParamsOnDeleteValue, resetSearchKeyword} = useSearchAsset(value, onChange);
  const {recentSearchKeywords, deleteRecentSearchKeyword} = useRecentSearchKeywords(onChange);

  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const inputBox = useRef(null);

  const openDropdown = useCallback(() => setIsDropdownOpened(true), []);
  const closeDropdown = useCallback(() => setIsDropdownOpened(false), []);

  const onClickDeleteBtn = () => {
    resetSearchKeyword();
    inputBox.current.focus();
    closeDropdown();
  };

  const onSubmitSearchKeyword = keyword => {
    searchAsset(keyword);
    closeDropdown();
  };

  useEffect(() => {
    if (isDropdownOpened) document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, [isDropdownOpened]);

  return (
    <View
      handleSubmit={handleSubmit}
      searchKeyword={value}
      onChange={onChange}
      onDeleteSearchKeyword={resetSearchParamsOnDeleteValue}
      onSubmitSearchKeyword={onSubmitSearchKeyword}
      recentSearchKeywords={recentSearchKeywords}
      deleteRecentSearchKeyword={deleteRecentSearchKeyword}
      isDropdownOpened={isDropdownOpened}
      inputBox={inputBox}
      openDropdown={openDropdown}
      onClickDeleteBtn={onClickDeleteBtn}
    />
  );
}

export default Container;
